import { ICellRendererParams } from 'ag-grid-community';
import SkeletonCell from 'lib/SkeletonCell/SkeletonCell';
import { ReactElement } from 'react';
import CopyToClipboardCellRenderer from './CopyToClipboardCellRenderer';

const copyableCellRenderer =
  (width = 'w-24') =>
  ({ data, value }: ICellRendererParams): ReactElement | string => {
    if (data?.isSkeletonRow) return <SkeletonCell width={width} />;
    if (!value) return '';
    return <CopyToClipboardCellRenderer value={value} />;
  };
export default copyableCellRenderer;
